module.exports = __webpack_public_path__ + "static/media/fly-out-star.2c258e74.png";